module.exports = __webpack_public_path__ + "img/65.0aed07e6.jpg";